import gsap from "gsap";
import { Box3, DataTexture, LinearFilter, PointLight, Quaternion, RepeatWrapping, RGBAFormat, SpotLight, Sprite, UnsignedByteType, Vector3,  } from "three";
import { MeshBasicMaterial, Line, LineBasicMaterial, BufferGeometry, SphereGeometry, Mesh, Texture
,CylinderGeometry, Group, MeshStandardMaterial, DoubleSide, CircleGeometry, SpriteMaterial, CanvasTexture } from "three";

export function createLabel(text) {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  // Set canvas size
  canvas.width = 256;
  canvas.height = 128;

  // Set the background to be transparent
  context.clearRect(0, 0, canvas.width, canvas.height);

  // Set text properties
  context.font = "40px Arial";
  context.fillStyle = "white";
  context.textAlign = "center";
  context.textBaseline = "middle";

  // Draw the text
  context.fillText(text, canvas.width / 2, canvas.height / 2);

  // Create texture from canvas
  const texture = new CanvasTexture(canvas);
  const spriteMaterial = new SpriteMaterial({ 
      map: texture, 
      transparent: true,
      depthTest: false // Disable depth testing
  });
  const sprite = new Sprite(spriteMaterial);

  // Set sprite scale
  sprite.scale.set(50, 25, 1); // Adjust scale as needed

  // Adjust rendering order
  sprite.renderOrder = 999;

  return sprite;
}

 export const createGradientCircle = (
    radius,
    x,
    y,
    z,
    colorSteps,
    visible = false
  ) => {
    const canvas = document.createElement("canvas");
    canvas.width = 128;
    canvas.height = 128;

    const context = canvas.getContext("2d");
    const gradient = context.createRadialGradient(
      canvas.width / 2,
      canvas.height / 2,
      0,
      canvas.width / 2,
      canvas.height / 2,
      canvas.width / 2
    );
    colorSteps.forEach((step) =>
      gradient.addColorStop(step.position, step.color)
    );
    context.fillStyle = gradient;
    context.fillRect(0, 0, canvas.width, canvas.height);

    let texture = new Texture(canvas);
    texture.needsUpdate = true;

    let geometry = new CircleGeometry(radius, 32);
    const material = new MeshBasicMaterial({
      map: texture,
      side: DoubleSide,
    });

    const circle = new Mesh(geometry, material);
    circle.rotation.x = -Math.PI / 2;
    circle.position.set(x, y, z);
    // console.log(circle);
    circle.visible = visible;
    
    circle.updateRadius = (offSet) => {
      circle.scale.set(1 + offSet / 10, 1 + offSet / 10, 1 + offSet / 10);
    };
    return circle;
  };

  export const handleCircleSize = (offset, circle) => {
    // console.log("mainCircle.current", mainCircle.current)
    // mainCircleRadiusOffset.current = offset;
    circle.radiusOffset = offset;
    circle.updateRadius(offset);
  };
  export function createDropLabel(text, fillStyle = "white", textColor = "black") {
      const canvas = document.createElement("canvas");
      canvas.width = 200; // Set the width of the canvas
      canvas.height = 200; // Set the height of the canvas
      const context = canvas.getContext("2d");
  
      // Draw a wider drop shape
      context.beginPath();
      context.moveTo(100, 40);
      context.bezierCurveTo(200, 74, 190, 134, 100, 160);
      context.bezierCurveTo(10, 134, 0, 74, 100, 40);
      context.fillStyle = fillStyle;
      context.fill();
  
      // Draw the text
      context.font = "30px Arial"; // Adjust the font size
      context.fillStyle = textColor;
      context.textAlign = "center";
      context.textBaseline = "middle";
      context.fillText(text, canvas.width / 2, canvas.height / 2); // Center the text vertically
  
      const texture = new CanvasTexture(canvas);
      const spriteMaterial = new SpriteMaterial({ map: texture });
      const sprite = new Sprite(spriteMaterial);
      sprite.scale.set(15, 15, 15); // scale the sprite to be wider
      sprite.name = text;
   
      return sprite;
    }
  export const createLine = (start, end, color) => {
      // Create a line
      const material = new LineBasicMaterial({ color: color });
      const points = [];
      points.push(start);
      points.push(end);
      const geometry = new BufferGeometry().setFromPoints(points);
      const line = new Line(geometry, material);
      return line;
    };
  export function animateCamera(camera, targetPosition, targetQuaternion, duration, easeName = "power4.out") {
    return new Promise((resolve) => {
      const animations = [];
  
      if (targetPosition) {
        animations.push(gsap.to(camera.position, {
          duration: duration,
          x: targetPosition.x,
          y: targetPosition.y,
          z: targetPosition.z,
          ease: easeName,
          onUpdate: () => {
            // camera.updateProjectionMatrix();
          },
        }));
      }
  
      if (targetQuaternion) {
        
        animations.push(gsap.to(camera.quaternion, {
          duration: duration,
          x: targetQuaternion.x,
          y: targetQuaternion.y,
          z: targetQuaternion.z,
          w: targetQuaternion.w,
          ease: easeName,
          onUpdate: () => {
            // camera.updateProjectionMatrix();
          },
        }));
      }
  
      gsap.timeline({ onComplete: resolve }).add(animations);
    });
  }
  export function animateCameraPosition(
    camera,
    targetPosition,
    duration,
    easeName = "power4.out"
  ) {
    if (targetPosition) {
      return new Promise((resolve) => {
        gsap.to(camera.position, {
          duration: duration,
          x: targetPosition.x,
          y: targetPosition.y,
          z: targetPosition.z,
          ease: easeName, // or any other easing function
          onUpdate: () => {
            // camera.updateProjectionMatrix();
          }, // required when the camera position is changing
          onComplete: resolve,
        });
      });
    }
  }
  export const createPointLight = (color, intensity, distance, decay, castShadow = true) => {
      const pointLight = new PointLight(color, intensity, distance, decay);
      pointLight.castShadow = castShadow;
      return pointLight;
  };
    export function createSpotlight( color, intensity = 1, penumbra = 1, distance = 0.5, decay = 0 ) {
  
          const newObj = new SpotLight( color, intensity );
  
          newObj.castShadow = true;
          // newObj.angle = 0.3;
          newObj.penumbra = penumbra;
          newObj.decay = decay;
          newObj.distance = distance;
  
          return newObj;
  
      }
  export const findMeshesInModelByName = (name, node) => {
    if (!node) return []

    let meshes = []
    if (node.children) {
        for (let child of node.children) {
            // console.log(child.name)
            if (child.name.includes(name)) {
                
                meshes.push(child)
            }
            meshes = meshes.concat(findMeshesInModelByName(name, child))
        }
    }
    return meshes
}
  export function animateCameraRotation(
    camera,
    targetRotation,
    duration,
    easeName = "power4.out"
  ) {
    if (targetRotation) {
      const targetQuaternion = new Quaternion().setFromEuler(targetRotation); 
      return new Promise((resolve) => {
        gsap.to(camera.quaternion, {
          duration: duration,
          x: targetQuaternion.x,
          y: targetQuaternion.y,
          z: targetQuaternion.z,
          w: targetQuaternion.w,
          ease: easeName, // or any other easing function
          onUpdate: () => {
            // camera.updateProjectionMatrix();
          }, // required when the camera position is changing
          onComplete: resolve,
        });
      });
    }
  }

  export function createSunPosition(elevation, azimuth) {
    const phi = (90 - elevation) * (Math.PI / 180); // Convert to radians
    const theta = azimuth * (Math.PI / 180); // Convert to radians
  
    const x = Math.sin(phi) * Math.cos(theta);
    const y = Math.cos(phi);
    const z = Math.sin(phi) * Math.sin(theta);
  
    return { x, y, z };
  }

  export function generateRadialFloorTexture(dim, color = { r: 134, g: 123, b: 145 }) {
    const data = new Uint8Array(dim * dim * 4);

    for (let x = 0; x < dim; x++) {
      for (let y = 0; y < dim; y++) {
        const xNorm = x / (dim - 1);
        const yNorm = y / (dim - 1);

        const xCent = 2.0 * (xNorm - 0.5);
        const yCent = 2.0 * (yNorm - 0.5);
        let a = Math.max(
          Math.min(1.0 - Math.sqrt(xCent ** 2 + yCent ** 2), 1.0),
          0.0
        );
        a = a ** 1.5;
        a = a * 1.5;
        a = Math.min(a, 1.0);

        const i = y * dim + x;
        data[i * 4 + 0] = color.r; // Red component
        data[i * 4 + 1] = color.g; // Green component
        data[i * 4 + 2] = color.b; // Blue component
        data[i * 4 + 3] = a * 255; // Alpha component
      }
    }

    const tex = new DataTexture(data, dim, dim);
    tex.format = RGBAFormat;
    tex.type = UnsignedByteType;
    tex.minFilter = LinearFilter;
    tex.magFilter = LinearFilter;
    tex.wrapS = RepeatWrapping;
    tex.wrapT = RepeatWrapping;
    tex.needsUpdate = true;
    return tex;
  }

  export const createCircle = (radius, x, y, z) => {
    const geometry = new CircleGeometry(radius, 32); // CircleGeometry(radius, segments), adjust radius as needed

    const material = new MeshBasicMaterial({
      color: 0x800080, // Hex color for purple
      side: DoubleSide,
    });

    const circle = new Mesh(geometry, material);
    circle.rotation.x = -Math.PI / 2; // Rotate the circle to be parallel to the ground
    // circle.position = position;
    circle.position.set(x, y, z); // Set the position here

    return circle;
  };
  export const getCurrentViewData = (camera) => {
    // console.log(camera.current);
    // const {position, rotation, quaternion} = camera.current
    const position = {
      x: camera.position.x,
      y: camera.position.y,
      z: camera.position.z,
    };
    const rotation = {
      x: camera.rotation.x,
      y: camera.rotation.y,
      z: camera.rotation.z,
    };
    const quaternion = {
      w: camera.quaternion.w,
      x: camera.quaternion.x,
      y: camera.quaternion.y,
      z: camera.quaternion.z,
    };
    return { position, rotation, quaternion };
  };
  export function calculateDestinationPoint(source, distance) {
    // Create a forward vector (0, 0, -1)
    const forward = new Vector3(0, 0, -1);
  
    // Apply the camera's quaternion to the forward vector to get the direction the camera is facing
    forward.applyQuaternion(source.quaternion);
  
    // Scale the direction vector by the desired distance
    forward.multiplyScalar(distance);
  
    // Add the scaled direction vector to the source's position to get the destination point
    const destination = new Vector3().copy(source.position).add(forward);
  
    return destination;
  }

  export const createUserMesh = () => {
      const group = new Group();
      // const bodyGeometry = new .CylinderGeometry(0.3, 0.3, 2, 32);
      const headGeometry = new SphereGeometry(0.5, 32, 32);
      // const bodyMaterial = new .MeshBasicMaterial({ color: "red" });
      const headMaterial = new MeshBasicMaterial({ color: "pink" });
  
      // const body = new .Mesh(bodyGeometry, bodyMaterial);
      const head = new Mesh(headGeometry, headMaterial);
      // humanGroupRef.current.add(body);
      return head
    };

  // export function createPodium() {
  //     let geometry, material;
   
  
  //     geometry = new CylinderGeometry(90, 110, 10, 64);
  //     material = new MeshStandardMaterial({
  //       // side: DoubleSide,
  //       // roughness: 1,
  //       // metalness: 1,
  //       // color: colors.primary,
  //       map: generateRadialFloorTexture(1024),
  //       transparent: true,
  //       // depthWrite: false,
  //     });
  
  //     const podium = new Mesh(geometry, material);
  //     podium.position.y = 6;
  //     podium.renderOrder = 1;
  //     podium.castShadow = true;
  //     podium.receiveShadow = true;
  //     return podium;
  //     // podium.rotateX( - Math.PI / 2 );
  //     // podiumRef.current = podium;
  //     // scene.current.add(podiumRef.current);
  //     // changePodiumSize(scale);
  //   }

  export const createArrowAndLabel = (
      model,
      position,
      rotation,
      labelName,
      labelPosition
    ) => {
      const group = new Group();
      group.name = labelName;
      group.position.set(...position);
      let arrow = model.clone();
      arrow.rotation.set(...rotation);
      group.add(arrow);
      const label = createLabel(labelName);
      label.position.y = 9;
      group.add(label);
      return group;
    };

  export const getModelSize = (model) => new Box3().setFromObject(model).getSize(new Vector3())